import { ActionIcon, Button } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconLogout } from '@tabler/icons-react'

import { useAuth } from '@/auth/use-auth'
import DSModalConfirm from '@/components/DSModalConfirm'

const LogoutButton = ({ openedSidebar }: { openedSidebar: boolean }) => {
  const { onSignOut } = useAuth()

  const [opened, { toggle }] = useDisclosure(false)

  return (
    <>
      <DSModalConfirm
        opened={opened}
        close={toggle}
        title="Logout"
        content="Are you sure you want to logout?"
        size="30%"
        onConfirm={onSignOut}
      />
      {openedSidebar ? (
        <Button
          variant="subtle"
          leftSection={<IconLogout size={18} color="#FFFFFF66" />}
          color="#FFFFFF"
          fw={400}
          w="100%"
          size="xs"
          justify="flex-start"
          onClick={toggle}
        >
          Log out
        </Button>
      ) : (
        <ActionIcon variant="subtle" aria-label="Logout" color="#FFFFFF66" onClick={toggle}>
          <IconLogout size={18} />
        </ActionIcon>
      )}
    </>
  )
}

export default LogoutButton
